import React, { useEffect } from 'react'
import arteImage from "../../assets/static/images/street-art 1.png";
import estadioImage from "../../assets/static/images/estadio 1.png";
import busImage from "../../assets/static/images/autobus-escolar 1.png";
import parqueImage from "../../assets/static/images/bicicleta 1.png";
import teatroImage from "../../assets/static/images/teatro 1.png";

import { format } from 'date-fns';
import { es } from 'date-fns/locale'
import axios from '../../api/axios';
import { useState } from 'react';
import { formatDate, sortHoraries, uppercaseFirstLetter } from '../../utils/utils';
import LoadingModal from '../loadingModal/LoadingModal';

import "../../assets/styles/Info.css";

const weekOrder = {
  lunes: 1,
  martes: 2,
  miércoles: 3,
  jueves: 4,
  viernes: 5,
  sabado: 6,
  domingo: 7,
}

const Info = () => {
  const [dates, setDates] = useState([]);
  const [actividades, setActividades] = useState([]);
  const [show, setShow] = useState(false);

  const formatDates = (date) => {
    return format(new Date(formatDate(date)), 'EEEE', { locale: es })
  }

  useEffect(() => {
    const getData = async () => {
      try {
        let response = await axios.get("turns/getDatesByActivity");
        setShow(true);

        if (response.data) {
          let result = response?.data?.reduce((a, b) => {
            if (a[b?.restriccion?.unidad?.name]) {

              if (!a[b?.restriccion?.unidad?.name].fechas?.some(f => f === formatDates(b.fecha))) {
                a[b?.restriccion?.unidad?.name].fechas = [
                  ...a[b?.restriccion?.unidad?.name].fechas,
                  formatDates(b.fecha)
                ];
              }
              if (!a[b?.restriccion?.unidad?.name].horarios?.some(f => f === b.horario)) {
                a[b?.restriccion?.unidad?.name].horarios = [
                  ...a[b?.restriccion?.unidad?.name].horarios,
                  b.horario
                ];
              }

              return a;
            } else {
              a[b?.restriccion?.unidad?.name] = {
                fechas: [formatDates(b.fecha)],
                horarios: [b.horario]
              }
              return a
            }
          }, {})

          setDates(result);
          setShow(false);
        } else {
          setDates([]);
          setShow(false);
        }
      } catch (err) {
        console.log(err);
        setShow(false);
      }
    }
    getData();


  }, []);

  useEffect(() => {
    const getData = async () => {
      let response = await axios.get("grades/getGrades");

      setActividades(response.data);
    }
    getData();

    return () => {
    };
  }, []);


  return (
    <div className='info'>
      <table className='info-table'>
        <thead>
          <tr className='table-title'>
            <td colSpan={5}>
              Actividades disponibles
            </td>
          </tr>
          <tr className='text-center info-names'>
            <td>CIRCUITO DE ARTE URBANO</td>
            <td>ESTADIO</td>
            <td>BUS TURÍSTICO</td>
            <td>ECO PARQUE</td>
            <td>TEATRO MUNICIPAL</td>
          </tr>
        </thead>
        <tbody>
          <tr className='table-images'>
            <td>
              <div>
                <img src={arteImage} alt="arte-urbano" />
              </div>
              <div>
                <span>Capacidad:</span>
                <span className='capacidad'>60 Personas</span>
              </div>
            </td>
            <td>
              <div>
                <img src={estadioImage} alt="arte-urbano" />
              </div>
              <div>
                <span>Capacidad:</span>
                <span className='capacidad'>60 Personas</span>
              </div>
            </td>
            <td>
              <div>
                <img src={busImage} alt="arte-urbano" />
              </div>
              <div>
                <span>Capacidad:</span>
                <span className='capacidad'>23 Personas</span>
              </div>
            </td>
            <td>
              <div>
                <img src={parqueImage} alt="arte-urbano" />
              </div>
              <div>
                <span>Capacidad:</span>
                <span className='capacidad'>60 Personas</span>
              </div>
            </td>
            <td>
              <div>
                <img src={teatroImage} alt="arte-urbano" />
              </div>
              <div>
                <span>Capacidad:</span>
                <span className='capacidad'>60 Personas</span>
              </div>
            </td>
          </tr>
          <tr className='table-title dates'>
            <td colSpan={5}>
              Días y horarios
            </td>
          </tr>
          <tr className='table-dates'>
            <td className='cell-horary'>
              <div>
                {
                  dates && dates['CIRCUITO DE ARTE URBANO'] && dates['CIRCUITO DE ARTE URBANO'].fechas?.length ? dates['CIRCUITO DE ARTE URBANO'].fechas?.sort((a, b) => weekOrder[a] - weekOrder[b]).map(e => {
                    return <span className='text-uppercase'>{e}</span>
                  })
                    : <>
                      <span>NO</span>
                      <span>DISPONIBLE</span>
                      <span>POR EL MOMENTO</span>
                    </>
                }
                {/* <span>LUNES</span>
                <span>MARTES</span>
                <span>JUEVES</span>
                <span>VIERNES</span> */}
              </div>
            </td>
            <td className='cell-horary'>
              <div>
                {
                  dates && dates['ESTADIO'] && dates['ESTADIO'].fechas?.length ? dates['ESTADIO'].fechas?.sort((a, b) => weekOrder[a] - weekOrder[b]).map(e => {
                    return <span className='text-uppercase'>{e}</span>
                  })
                    : <>
                      <span>NO</span>
                      <span>DISPONIBLE</span>
                      <span>POR EL MOMENTO</span>
                    </>
                }
                {/* <span>LUNES</span>
                <span>MIERCOLES</span>
                <span>JUEVES</span>
                <span>VIERNES</span> */}
              </div>
            </td>
            <td className='cell-horary'>
              <div>
                {
                  dates && dates['BUS'] && dates['BUS'].fechas?.length ? dates['BUS'].fechas?.sort((a, b) => weekOrder[a] - weekOrder[b]).map(e => {
                    return <span className='text-uppercase'>{e}</span>
                  })
                    : <>
                      <span>NO</span>
                      <span>DISPONIBLE</span>
                      <span>POR EL MOMENTO</span>
                    </>
                }
                {/* <span>MARTES</span>
                <span>MIERCOLES</span>
                <span>JUEVES</span>
                <span>VIERNES</span> */}
              </div>
            </td>
            <td className='cell-horary'>
              <div>
                {
                  dates && dates['ECOPARQUE'] && dates['ECOPARQUE'].fechas?.length ? dates['ECOPARQUE'].fechas?.sort((a, b) => weekOrder[a] - weekOrder[b]).map(e => {
                    return <span className='text-uppercase'>{e}</span>
                  })
                    : <>
                      <span>NO</span>
                      <span>DISPONIBLE</span>
                      <span>POR EL MOMENTO</span>
                    </>
                }
              </div>
              {/* 
                <span>LUNES</span>
                <span>MARTES</span>
                <span>MIERCOLES</span>
                <span>JUEVES</span>
              */}
            </td>
            <td className='cell-horary'>
              <div>
                {
                  dates && dates['TEATRO'] ? dates['TEATRO'].fechas?.sort((a, b) => weekOrder[a] - weekOrder[b]).map(e => {
                    return <span className='text-uppercase'>{e}</span>
                  })
                    : <>
                      <span>NO</span>
                      <span>DISPONIBLE</span>
                      <span>POR EL MOMENTO</span>
                    </>
                }
              </div>
            </td>
          </tr>
          <tr className='table-horaries'>
            <td>
              {
                dates && dates['CIRCUITO DE ARTE URBANO'] ? sortHoraries(dates['CIRCUITO DE ARTE URBANO'].horarios).map((e, i) => {
                  let [hour, minute] = e?.split(":");
                  if (i === dates['CIRCUITO DE ARTE URBANO'].horarios.length - 1) return <span className=''>{`${hour}${+minute ? `.${minute}` : ""} hs`}</span>
                  return <span className=''>{`${hour}${+minute ? `.${minute}` : ""} hs | `}</span>
                })
                  : ""
              }
            </td>
            <td>
              {
                dates && dates['ESTADIO'] ? sortHoraries(dates['ESTADIO'].horarios).map((e, i) => {
                  let [hour, minute] = e?.split(":");
                  if (i === dates['ESTADIO'].horarios.length - 1) return <span className=''>{`${hour}${+minute ? `.${minute}` : ""} hs`}</span>
                  return <span className=''>{`${hour}${+minute ? `.${minute}` : ""} hs | `}</span>
                })
                  : ""
              }
            </td>
            <td>
              {
                dates && dates['BUS'] ? sortHoraries(dates['BUS'].horarios).map((e, i) => {
                  let [hour, minute] = e?.split(":");
                  if (i === dates['BUS'].horarios.length - 1) return <span className=''>{`${hour}${+minute ? `.${minute}` : ""} hs`}</span>
                  return <span className=''>{`${hour}${+minute ? `.${minute}` : ""} hs | `}</span>
                })
                  : ""
              }
            </td>
            <td>
              {
                dates && dates['ECOPARQUE'] ? sortHoraries(dates['ECOPARQUE'].horarios).map((e, i) => {
                  let [hour, minute] = e?.split(":");
                  if (i === dates['ECOPARQUE'].horarios.length - 1) return <span className=''>{`${hour}${+minute ? `.${minute}` : ""} hs`}</span>
                  return <span className=''>{`${hour}${+minute ? `.${minute}` : ""} hs | `}</span>
                })
                  : ""
              }
            </td>
            <td>
              {
                dates && dates['TEATRO'] ? sortHoraries(dates['TEATRO'].horarios).map((e, i) => {
                  let [hour, minute] = e?.split(":");
                  if (i === dates['TEATRO'].horarios.length - 1) return <span className=''>{`${hour}${+minute ? `.${minute}` : ""} hs`}</span>
                  return <span className=''>{`${hour}${+minute ? `.${minute}` : ""} hs | `}</span>
                })
                  : ""
              }
            </td>


            {/* <td>10 hs | 14 hs</td>
            <td>10 hs | 14 hs</td>
            <td>8.30 hs | 10.30 hs | 13.30 hs | 15.30 hs</td>
            <td>10 hs | 14 hs</td> 
            <td></td>*/}
          </tr>
          <tr className='table-message'>
            <td colSpan={5} className="text-danger" style={{ paddingTop: 20, paddingBottom: 10 }} >
              *72 hs antes de la actividad el colegio deberá presentar la salida educativa aprobada por la jefatura distrital de educación.
            </td>
          </tr>
          <tr className='table-message'>
            <td colSpan={5} className="text-danger" style={{ paddingTop: 10, paddingBottom: 20 }}>
              EL TRANSPORTE HACIA LA VISITA CORRE POR CUENTA DE CADA INSTITUCIÓN Y NO DEL PROGRAMA.
            </td>
          </tr>
        </tbody>
      </table>

      <table className='info-table'>
        <thead>
          <tr className='table-title'>
            <th colSpan={2}>
              Actividades por ciclo
            </th>
          </tr>
          <tr className='table-name-level'>
            <th>NIVEL PRIMARIO</th>
            <th>NIVEL SECUNDARIO</th>
          </tr>
        </thead>
        <tbody>
          <tr className='table-grades'>
            <td className='table-level'>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>1er Año</td>
                      <td className='table-arrow'>&#x279c;</td>
                      <td>{actividades?.length ? actividades?.find(e => e.grado === "1° Año (Nivel primario)") ?
                        uppercaseFirstLetter(actividades.find(e => e.grado === "1° Año (Nivel primario)").actividades?.actividad) : <span className="not-available-message">No disponible por el momento</span>
                        : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>2do Año</td>
                      <td className='table-arrow'>&#x279c;</td>
                      <td>{actividades?.length ? actividades?.find(e => e.grado === "2° Año (Nivel primario)") ?
                        uppercaseFirstLetter(actividades.find(e => e.grado === "2° Año (Nivel primario)").actividades?.actividad) : <span className="not-available-message">No disponible por el momento</span>
                        : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>3er Año</td>
                      <td className='table-arrow'>&#x279c;</td>
                      <td>{actividades?.length ? actividades?.find(e => e.grado === "3° Año (Nivel primario)") ?
                        uppercaseFirstLetter(actividades.find(e => e.grado === "3° Año (Nivel primario)").actividades?.actividad) : <span className="not-available-message">No disponible por el momento</span>
                        : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>4to Año</td>
                      <td className='table-arrow'>&#x279c;</td>
                      <td>{actividades?.length ? actividades?.find(e => e.grado === "4° Año (Nivel primario)") ?
                        uppercaseFirstLetter(actividades.find(e => e.grado === "4° Año (Nivel primario)").actividades?.actividad) : <span className="not-available-message">No disponible por el momento</span>
                        : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>5to Año</td>
                      <td className='table-arrow'>&#x279c;</td>
                      <td>{actividades?.length ? actividades?.find(e => e.grado === "5° Año (Nivel primario)") ?
                        uppercaseFirstLetter(actividades.find(e => e.grado === "5° Año (Nivel primario)").actividades?.actividad) : <span className="not-available-message">No disponible por el momento</span>
                        : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>6to Año</td>
                      <td className='table-arrow'>&#x279c;</td>
                      <td>{actividades?.length ? actividades?.find(e => e.grado === "6° Año (Nivel primario)") ?
                        uppercaseFirstLetter(actividades.find(e => e.grado === "6° Año (Nivel primario)").actividades?.actividad) : <span className="not-available-message">No disponible por el momento</span>
                        : ""}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
            <td className='table-level'>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>1er Año</td>
                      <td className='table-arrow'>&#x279c;</td>
                      <td>{actividades?.length ? actividades?.find(e => e.grado === "1° Año (Nivel secundario)") ?
                        uppercaseFirstLetter(actividades.find(e => e.grado === "1° Año (Nivel secundario)").actividades?.actividad) : <span className="not-available-message">No disponible por el momento</span>
                        : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>2do Año</td>
                      <td className='table-arrow'>&#x279c;</td>
                      <td>{actividades?.length ? actividades?.find(e => e.grado === "2° Año (Nivel secundario)") ?
                        uppercaseFirstLetter(actividades.find(e => e.grado === "2° Año (Nivel secundario)").actividades?.actividad) : <span className="not-available-message">No disponible por el momento</span>
                        : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>3er Año</td>
                      <td className='table-arrow'>&#x279c;</td>
                      <td>{actividades?.length ? actividades?.find(e => e.grado === "3° Año (Nivel secundario)") ?
                        uppercaseFirstLetter(actividades.find(e => e.grado === "3° Año (Nivel secundario)").actividades?.actividad) : <span className="not-available-message">No disponible por el momento</span>
                        : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>4to Año</td>
                      <td className='table-arrow'>&#x279c;</td>
                      <td>{actividades?.length ? actividades?.find(e => e.grado === "4° Año (Nivel secundario)") ?
                        uppercaseFirstLetter(actividades.find(e => e.grado === "4° Año (Nivel secundario)").actividades?.actividad) : <span className="not-available-message">No disponible por el momento</span>
                        : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>5to Año</td>
                      <td className='table-arrow'>&#x279c;</td>
                      <td>{actividades?.length ? actividades?.find(e => e.grado === "5° Año (Nivel secundario)") ?
                        uppercaseFirstLetter(actividades.find(e => e.grado === "5° Año (Nivel secundario)").actividades?.actividad) : <span className="not-available-message">No disponible por el momento</span>
                        : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>6to Año</td>
                      <td className='table-arrow'>&#x279c;</td>
                      <td>{actividades?.length ? actividades?.find(e => e.grado === "6° Año (Nivel secundario)") ?
                        uppercaseFirstLetter(actividades.find(e => e.grado === "6° Año (Nivel secundario)").actividades?.actividad) : <span className="not-available-message">No disponible por el momento</span>
                        : ""}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      {show ? <LoadingModal show={show} /> : ''}
    </div>
  )
}

export default Info